import {UserRole} from 'types';

export type RoleFlags = {
	isAdmin: boolean;
	isVko: boolean;
	isVkoExternal: boolean;
	isVex: boolean;
	isVexSupport: boolean;
	isServiceProvider: boolean;
	isApprover: boolean;
	isReader: boolean;
	isRegulationReader: boolean;
	isBav: boolean;
	isBedarfskoordinator: boolean;
	isAvk: boolean;
	/** Maintains machine master data (Anlagenvorschriften) in the admin panel. */
	isAvkAdmin: boolean;
};

/**
 * Boolean role flags for a role set (the full union, or a narrowed active subset).
 */
export const computeRoleFlags = (roles: UserRole[]): RoleFlags => {
	const rolesLower = roles.map(role => role.toLowerCase());

	const isAdmin = roles.includes(UserRole.SystemAdministrator);
	const isVko = roles.includes(UserRole.Vko);
	const isVkoExternal = roles.includes(UserRole.VkoExternal);
	const isVexSupport = rolesLower.includes(UserRole.VexSupport.toLowerCase());
	const isVex = roles.includes(UserRole.Vex) || isVexSupport;
	const isServiceProvider = roles.includes(UserRole.ServiceProvider);
	const isApprover = roles.includes(UserRole.ShApprover);
	const isRegulationReader = roles.includes(UserRole.RegulationReader);
	const isBedarfskoordinator = roles.includes(UserRole.Bedarfskoordinator);
	const isAvk = roles.includes(UserRole.Avk);
	const isBav = roles.includes(UserRole.Bav);
	const isAvkAdmin = roles.includes(UserRole.AvkAdministrator);
	// Reader is the implicit fallback: true only when no elevated role is present.
	const isReader =
		!isAdmin &&
		!isVko &&
		!isVkoExternal &&
		!isVex &&
		!isServiceProvider &&
		!isApprover &&
		!isRegulationReader &&
		!isBav &&
		!isBedarfskoordinator &&
		!isAvk &&
		!isVexSupport &&
		!isAvkAdmin &&
		rolesLower.includes(UserRole.Readers.toLowerCase());

	return {
		isAdmin,
		isVko,
		isVkoExternal,
		isVex,
		isVexSupport,
		isServiceProvider,
		isApprover,
		isReader,
		isRegulationReader,
		isBav,
		isBedarfskoordinator,
		isAvk,
		isAvkAdmin,
	};
};
